module.exports = __webpack_public_path__ + "img/Samsung_case_study_3.6e8f3333.jpg";